import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import style from './LoaderCarousel.module.sass'

type LoaderCarouselProps = {
	amount?: number
}

export const LoaderCarousel: FunctionComponent<LoaderCarouselProps> = ({ amount = 6 }) => {
	return (
		<div className={style.cardGroupWrapper}>
			{[...Array(amount)].map((_elem, index) => (
				<div key={index} className={style.cardWrapper}>
					<div className={clsx(style.loading, style.loadingImage)} />
					<div className={clsx(style.loading, style.loadingTitle)} />
					<div className={clsx(style.loading, style.loadingLead)} />
					<div className={clsx(style.loading, style.loadingButton)} />
				</div>
			))}
		</div>
	)
}
